// @flow
// @jsx h

import { h } from "preact";

import { ListIcon, CardsIcon } from "elc-icons";
import {ThemeConfig} from "elc-theme"

import styles from "./style.scss";

/**
 * Bank check payment confirmation Component
 */
const ProductsViewToggle = (
  {
    setProductsViewModeList,
    setProductsViewModeGrid,
    productsListViewMode
  }: {
    setProductsViewModeList: Function,
    setProductsViewModeGrid: Function,
    productsListViewMode: boolean
  },
  context
) => (
  <ThemeConfig.Consumer>
  { themeConfig => {
     return(
          <div class={styles.viewModes}>
            <button
              onClick={setProductsViewModeList}
              class={`${styles.changeViewButton} ${
                productsListViewMode ? styles.viewActive : ""
              }`}
              style={
                themeConfig &&
                themeConfig.color1 &&
                productsListViewMode
                  ? "background-color: " + themeConfig.color1
                  : ""
              }
            >
              <ListIcon />
            </button>
            <button
              onClick={setProductsViewModeGrid}
              class={`${styles.changeViewButton} ${
                !productsListViewMode ? styles.viewActive : ""
              }`}
              style={
                themeConfig &&
                themeConfig.color1 &&
                !productsListViewMode
                  ? "background-color: " + themeConfig.color1
                  : ""
              }
            >
              <CardsIcon />
            </button>
          </div>
        )}
      }
    </ThemeConfig.Consumer>
);

export default ProductsViewToggle;
